import { mergeClasses } from '@/utils';

import { EmptyBoxIcon } from '@/assets/icons';

export const NotFoundResult = ({ label, className }: { label?: string; className?: string }) => {
  return (
    <div
      className={mergeClasses(
        'flex flex-col items-center justify-center bg-transparent overflow-y-auto h-[55vh] gap-6',
        className,
      )}
    >
      <EmptyBoxIcon className="flex-shrink-0" />
      <span className="font-medium text-base text-neutral-7">
        {label ? label : 'No results found.'}
      </span>
    </div>
  );
};
